import InputPadService from '@/services/InputPadService';
import router from '@/router';
import {
  SET_CURRENT_INPUT_PAD, ON_INPUT_PAD_BLUR, SET_INPUT_PAD_LENGTH,
} from '../mutation-types';
import { ON_INPUT_PAD } from '../action-types';
// state
const localState = {
  currentInputPad: {
    element: null,
    item: null,
    property: null,
    maxLength: 4,
    alphabetable: false,
    usingDecimal: true,
  },
  inputHolderFocusing: 0,
  blurTimeout: null,
  textLength: 0,
  textLengthMeasurer: null,
};

// mutations
const mutations = {
  [SET_CURRENT_INPUT_PAD](state, currentInputPad) {
    state.currentInputPad = currentInputPad;
    state.currentInputPad.element.select();
    state.inputHolderFocusing += 1;
    InputPadService.refreshCursor(state, this.blurTimeout);
  },
  [ON_INPUT_PAD_BLUR](state, force = false) {
    if (force) {
      state.inputHolderFocusing = 0;
      state.currentInputPad = {};
    } else {
      this.blurTimeout = setTimeout(() => {
        state.inputHolderFocusing = 0;
        state.currentInputPad = {};
      }, 500);
    }
  },
  [SET_INPUT_PAD_LENGTH](state, element) {
    state.textLengthMeasurer = element;
  },
};

const actions = {
  [ON_INPUT_PAD]({state, rootState}, char) {
    const input = state.currentInputPad;
    if (!input.element) {
      if(router.currentRoute.name == 'order') {
        rootState.bill.currentQuantityIncrease = isNaN(parseInt(char)) ? 1 : parseInt(char);
      }
      return;
    }
    InputPadService.setInput(input, char, state);
    state.inputHolderFocusing += 1;
    InputPadService.refreshCursor(state, this.blurTimeout);
  },
};

export default {
  state: localState,
  mutations,
  actions,
};
